import { render, staticRenderFns } from "./data_filter.vue?vue&type=template&id=50d546ff&scoped=true"
import script from "./data_filter.vue?vue&type=script&lang=js"
export * from "./data_filter.vue?vue&type=script&lang=js"
import style0 from "./data_filter.vue?vue&type=style&index=0&id=50d546ff&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50d546ff",
  null
  
)

export default component.exports